import { useFetchApartments } from "../useFetchApartments.js";
import Hero from "../Sections/Hero";
import { FAQ } from '../Sections/FAQ/FAQ.tsx';
import { Testimonials } from "../Sections/Testimonials.tsx";
import { RecommendedApartments } from "../Sections/Apartments/RecommendedApartments.tsx";
import Loading from "./Loading.jsx"
import "../Styling/Home.css";
import Pricing from "../Sections/Pricing.jsx";
import { Helmet } from "react-helmet";
export default function Home({ t, language }) {
  const { apartments, apartmentImages, loading } = useFetchApartments();
  return (

    <div>
        <Helmet>
        <title>Apartment Rentals near Bovansko Lake | [Your Website Name]</title>
        <meta
          name="description"
          content="Find the perfect apartment for your vacation near Bovansko Lake. Browse our selection of affordable and luxury apartments."
        />
        <meta
          name="keywords"
          content="apartmani, smestaj, izdavanje, bovansko jezero, sokobanja, odmor, letovanje, zimovanje, povoljni apartmani, luksuzni apartmani"
        />
      </Helmet>
      <Hero t={t} />
      {loading ? (
        <Loading />
      ) : (
        <RecommendedApartments
          language={language}
          t={t}
          apartments={apartments}
          apartmentImages={apartmentImages}
          reccomend={true}
        />
      )}
      <FAQ language={language} t={t} />
      <Pricing t={t} apartments = {apartments} language={language}/>
      <Testimonials t={t} />
    </div>
  );
}
